import {combine, merge, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';

import {mapSortings} from 'utils/grid-mappers';

import {
    createCustomsUserFx,
    customs$,
    customsUserIdsForUnboundConfirmation$,
    data$,
    editUserData$,
    fetchCustomsFx,
    fetchDataFx,
    Gate,
    onChangeCustomsUserIdForUnboundConfirmation,
    onSetEditUser,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    search$,
    searchChanged,
    sortings$,
    unboundCustomsUserFx,
    updateCustomsUserFx,
} from './index';

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);
customsUserIdsForUnboundConfirmation$
    .on(onChangeCustomsUserIdForUnboundConfirmation, (_, payload) => payload)
    .reset(Gate.close);
customs$.on(fetchCustomsFx.doneData, (_, data) => data).reset(Gate.close);
editUserData$.on(onSetEditUser, (_, payload) => payload);
pageNumber$.reset(Gate.close);
pageSize$.reset(Gate.close);

sample({
    clock: Gate.open,
    source: Gate.state,
    fn: (state) => state.id,
    target: fetchCustomsFx,
});

sample({
    clock: merge([
        Gate.open,
        pageNumberChanged,
        pageSizeChanged,
        searchChanged,
        unboundCustomsUserFx.done,
    ]),
    source: combine({
        sortings: sortings$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        searchField: search$,
        state: Gate.state,
    }),
    fn: ({state, sortings, pageNumber, pageSize, searchField}) => ({
        paging: {pageSize, pageNumber},
        sortings: mapSortings(sortings),
        searchField,
        id: state.id,
    }),
    target: fetchDataFx,
});

createCustomsUserFx.doneData.watch(() =>
    toast.success(i18next.t('pages.customsUsers.create.messages.create')),
);
updateCustomsUserFx.doneData.watch(() =>
    toast.success(i18next.t('pages.customsUsers.create.messages.update')),
);
unboundCustomsUserFx.doneData.watch(() =>
    toast.success(i18next.t('pages.customsUsers.create.messages.remove')),
);

[fetchDataFx, createCustomsUserFx, unboundCustomsUserFx].forEach((fx) =>
    fx.failData.watch((err) => showRestError(err as RestError)),
);
